import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from 'components/button';

import styles from './preview-error-modal.module.scss';
import { Modal } from 'components/modal/modal';

export interface IPreviewErrorModalProps {
	isOpen: boolean;
}

const handleRefresh = (): void => {
	window.location.reload();
};

const PreviewErrorModal = ({ isOpen }: IPreviewErrorModalProps): React.JSX.Element => {
	const intl = useIntl();

	return (
		<Modal
			isOpen={isOpen}
			onClose={handleRefresh}
			title={intl.formatMessage({ id: 'preview.error.title' })}
			maxWidth={480}
			className={styles.previewErrorModal}
		>
			<div className={styles.content}>
				<p className={styles.description}>{intl.formatMessage({ id: 'preview.error.description' })}</p>
				<Button
					variant="primary"
					title={intl.formatMessage({ id: 'preview.error.refresh' })}
					onClick={handleRefresh}
					fullWidth
				/>
			</div>
		</Modal>
	);
};

export { PreviewErrorModal };
